export const toFormattedInteger = (value: number, zero = '0'): string => {
    return isNaN(value) ? zero : value.toLocaleString();
}
